import { CombinedManualAdjustmentType, PairedCostVersion } from '@aloft/toolkit-shared';

const invalidTypesForV1: CombinedManualAdjustmentType[] = [
  'bathAboveGrade',
  'bathBelowGrade',
  'locationView',
  'externalObsolescence',
  'foundation',
  'units',
];

const invalidTypesForV2: CombinedManualAdjustmentType[] = [
  'termsOfSale',
  'concessions',
  'locationView',
  'manufactured',
  'belowGradeANSI',
  'bonusRoom',
];

export function isValidAdjForVersion(
  adj: CombinedManualAdjustmentType,
  version: PairedCostVersion,
): boolean {
  switch (version) {
    case 'legacy':
      return !invalidTypesForV1.includes(adj);
    case '2.0':
      return !invalidTypesForV2.includes(adj);
    default:
      return true;
  }
}
